import React from 'react'

export const TitlePages = ({title}) => {
  return (
    <h4>{title}</h4>
  )
}

export default TitlePages